import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/file.svg'


const _withScopeId = n => (_pushScopeId("data-v-610295e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "files" }
const _hoisted_2 = {
  key: 0,
  class: "subpage-title"
}
const _hoisted_3 = { class: "file-wrapper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "casedrive file"
  })
], -1))
const _hoisted_6 = { class: "file-name" }
const _hoisted_7 = {
  class: "file-box spacer",
  ref: "spacer"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "no-files"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_files = _resolveComponent("drive-files")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.driveStore.currentCase.files.length || !_ctx.isNetwork)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$localize('drive.view.case.file.tab.title')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driveStore.currentCase.files, (file) => {
        return (_openBlock(), _createElementBlock("div", {
          key: file.id,
          style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
          onClick: ($event: any) => (_ctx.openFile(file)),
          class: "file-box"
        }, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(file.name), 1)
        ], 12, _hoisted_4))
      }), 128)),
      _createElementVNode("div", _hoisted_7, null, 512)
    ]),
    (!_ctx.driveStore.currentCase.files.length && !_ctx.isNetwork)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_drive_files, {
            files: [],
            title: "",
            hideBorder: _ctx.HIDE_BORDER.ALL,
            isPreviewCase: _ctx.isPreviewCase
          }, null, 8, ["hideBorder", "isPreviewCase"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.driveStore.currentCase.files.length && _ctx.isNetwork)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('shared.case.photos.overview.no.files')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}